import Utils from '@/ecm/common/Utils';
export default class ContentTypeFieldRight {
    constructor (dto) {
        this.uuid = Utils.object.getUUID();
        this.roleTypeID = '';
        this.defFieldID = '';
        this.visible = true;
        this.readonly = false;
        this.conditionStr = '';
        this.displayConditionStr = '';

        if (dto) {
            Object.assign(this, dto, {
                roleTypeID: dto.roleTypeID + '',
                defFieldID: dto.defFieldID + ''
            });
        }
    }

    toDto () {
        return {
            RoleTypeID: this.roleTypeID,
            DefFieldID: this.defFieldID,
            Visible: this.visible,
            Readonly: this.readonly,
            ConditionStr: this.conditionStr,
        };
    }
}
